export class ZeroEtlJobSync {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceTable",
            "baseName": "sourceTable",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetNamespace",
            "baseName": "targetNamespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetTable",
            "baseName": "targetTable",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ZeroEtlJobSyncStatus",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        },
        {
            "name": "errorCode",
            "baseName": "errorCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "batchId",
            "baseName": "batchId",
            "type": "string",
            "format": ""
        },
        {
            "name": "writerEngine",
            "baseName": "writerEngine",
            "type": "string",
            "format": ""
        },
        {
            "name": "attempt",
            "baseName": "attempt",
            "type": "number",
            "format": ""
        },
        {
            "name": "supersededByJobId",
            "baseName": "supersededByJobId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "rowsAdded",
            "baseName": "rowsAdded",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rowsDeleted",
            "baseName": "rowsDeleted",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlJobSync.attributeTypeMap;
    }
    constructor() {
    }
}
